import { Empty, Tabs } from 'antd';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Autoplay } from 'swiper';
import HomeTitle from '@/comps/HomeTitle';
const { TabPane } = Tabs;
import useUrl from 'hooks/useUrl';
import ImgTag from 'comps/ImgTag';
// import DetailIcon from 'images/cscec3b/factory-direct-icon@2x.png';
import FactoryDirectBg from '@/images/cscec3b/home/factory-direct-bg.png';
import 'swiper/css';

SwiperCore.use([Autoplay]);
type FactoryDirectProps = {
  floorData: {
    title: string;
    children: any;
  };
};
type ItemProps = {
  item: {
    sysNo: string;
    name: string;
    imagePath?: string;
    manufacturer?: string;
    priceAdvantage?: string;
    procurementService?: string;
    saleArea?: string;
    url?: string;
  };
};

var GoodsItem = ({ item }: ItemProps) => {
  const { getPublicUrl } = useUrl();
  const { name, imagePath, manufacturer, priceAdvantage, saleArea, url } = item;

  return (
    <div className="goods-item">
      <a className="goods-img" target="_blank" rel="noreferrer" href={url} title={name}>
        <ImgTag
          width={288}
          height={160}
          image={getPublicUrl(imagePath)}
          borderRadius={0}
          borderTopLeftRadius={16}
          borderTopRightRadius={16}
          titleName={name}
        />
      </a>
      <div className="goods-detail">
        {/* <img src={DetailIcon} className="top-icon" alt="" /> */}
        <h2 className="detail-title" title={manufacturer}>
          {manufacturer}
        </h2>
        <ul className="detail-content">
          <li>
            销售区域：<span title={saleArea}>{saleArea}</span>
          </li>
          <li>
            价格优势：<span title={priceAdvantage}>{priceAdvantage}</span>
          </li>
        </ul>
        <a target="_blank" rel="noreferrer" href={url} className="show-more">
          了解更多
          <span>&gt;</span>
        </a>
      </div>
      <style jsx>{`
                .goods-item {
                    width: 288px;
                    background-color: #fff;
                    border-radius: 16px;
                }
                .goods-item:nth-child(3n) {
                    margin-right: 0;
                }
                .goods-item:nth-child(n-3) {
                    margin-top: 12px;
                }
                .goods-item :global(.name-tag) {
                    border: none;
                    padding: 4px 6px;
                    line-height: 12px;
                    border-radius: 4px;
                    background: linear-gradient(90deg, #F31E10 0%, #F26255 100%);
                }
                .goods-img {
                    display: block;
                    width: 100%;
                    height: 160px;
                    background-position: center;
                    // background-size: contain;
                    background-size: 100% 100%;
                    background-repeat: no-repeat;
                }
                .goods-detail {
                    padding: 10px 20px;
                    background-color: #fff;
                    border-radius: 0 0 16px 16px;
                }
                .top-icon {
                    width: 40px;
                    height: 40px;
                    border-radius: 16px;
                }
                .detail-title {
                    font-size: 18px;
                    color: #212529;
                    font-weight: 600;
                    line-height: 24px;
                    margin: 10px 0;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                .detail-content li {
                    color: #737687;
                    font-size: 14px;
                    line-height: 19px;
                    margin-bottom: 5px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                .show-more {
                    display: inline-block;
                    margin-top: 10px;
                }
                .show-more span {
                    margin-left: 5px;
                }
            `}</style>
    </div>
  );
};

var FactoryDirect = (props: FactoryDirectProps) => {
  const { getPublicUrl } = useUrl();
  const { floorData } = props;
  const { title, children = [] } = floorData;
  const list = [...children];
  return (
    <div className="wrap">
      <div className="main-container">
        <HomeTitle title={title} />
        <Tabs defaultActiveKey="0" tabPosition="top" animated centered>
          {list?.map((item, index) => (
            <TabPane
              tab={
                <div className="tab-bar">
                  <img src={getPublicUrl(item.imagePath)} className="tab-icon" alt="" />
                  <ul>
                    <li className="tab-title">{item.name}</li>
                    <li className="tab-tips">{item.description}</li>
                  </ul>
                </div>
              }
              key={index}
            >
              <Swiper
                spaceBetween={0}
                slidesPerView={4}
                slidesPerGroup={1}
                loopedSlides={4}
                autoplay={{ pauseOnMouseEnter: true, disableOnInteraction: false }}
                className="mySwiper"
                noSwiping
                observer
                observeParents
              >
                <div className="goods-list">
                  {item?.children?.length ? (
                    item.children.map((v, i) => (
                      <SwiperSlide key={i}>
                        <GoodsItem item={v} key={i} />
                      </SwiperSlide>
                    ))
                  ) : (
                    <div className="no-data">
                      <Empty />
                    </div>
                  )}
                </div>
              </Swiper>
            </TabPane>
          ))}
        </Tabs>
      </div>
      <style jsx>{`
        .wrap {
          background-image: url(${FactoryDirectBg});
          background-size: cover;
          padding-bottom: 80px;
        }
        .main-container {
            width: 1200px;
            height: auto;
            margin: 0 auto;
        }
        .goods-list {
            display: flex;
            width: 100%;
            overflow: hidden;
        }
        .no-data {
            width: 100%;
            height: 240px;
            display: flex;
            justify-content: center;
            align-items: flex-end;
            font-size: 14px;
            color: #999;
        }
        .main-container :global(.more .btn) {
            cursor: pointer;
            margin-top: 20px;
        }
        .tab-bar {
            display: flex;
            align-items: center;
            padding: 0 25px;
        }
        .tab-icon {
            width: 42px;
            height: 42px;
            margin-right: 10px;
        }
        .tab-title {
            font-size: 18px;
            color: #212529;
            font-weight: 600;
            line-height: 27px;
        }
        .tab-tips {
            font-size: 13px;
            color: #737687;
            line-height: 19px;
        }
    `}</style>
    </div>
  );
};
export default FactoryDirect;
